import React, { useState } from 'react'
import styled from '@emotion/styled'
import { css, keyframes } from '@emotion/core'
import tw from 'twin.macro'
import PropTypes from 'prop-types'
import hexToRgba from 'hex-to-rgba';

const CircleComponent = ({ children, size, background, opacity, className, floating }) => {

  Number.random = (minimum, maximum, precision) => {
    minimum = minimum === undefined ? 0 : minimum;
    maximum = maximum === undefined ? 9007199254740992 : maximum;
    precision = precision === undefined ? 0 : precision;
    const random = Math.random() * (maximum - minimum) + minimum;
    return random.toFixed(precision);
  }

  const directions = ['left', 'right'];

  const [duration] = useState(Number.random(2, 6, 2));
  const [orbit] = useState(Number.random(8, 16, 0));
  const [direction] = useState(directions[Number.random(0, 1, 0)]);

  const backgroundColor = {
    backgroundColor: hexToRgba(background, opacity),
  };

  const floatright = keyframes`
    0% { transform: rotate(0deg) translate(-${orbit}px) rotate(0deg); }
  	100% { transform: rotate(360deg) translate(-${orbit}px) rotate(-360deg); }
  `
  const floatleft = keyframes`
    0% { transform: rotate(360deg) translate(-${orbit}px) rotate(-360deg); }
  	100% { transform: rotate(0deg) translate(-${orbit}px) rotate(0deg); }
  `
  const float = direction == 'left' ? floatleft : floatright;

  return (
    <svg className={`${className} circle`} css={floating == true ? css`animation: ${float} ${duration}s linear infinite` : ''}>
      <foreignObject width={size} height={size} x={size / 2} y={size / 2} transform={`translate(-${size / 2},-${size / 2})`}>
        <div className="content" style={backgroundColor}>{children}</div>
      </foreignObject>
    </svg>
  )
}
CircleComponent.propTypes = {
  children: PropTypes.node,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  color: PropTypes.string,
  background: PropTypes.string,
  opacity: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string.isRequired,
  floating: PropTypes.bool,
}
CircleComponent.defaultProps = {
  size: '214',
  color: '#111',
  background: '#ffffff',
  opacity: '0.8',
  floating: true,
};


const Circle = styled(CircleComponent)`
  ${tw``}
  height: ${props => props.size}px;
  width: ${props => props.size}px;
  .content {
    height: 100%;
    line-height: ${props => props.size}px;
    box-sizing: border-box;
    padding: 0 20%;
    border-radius: 100%;
    text-align: center;
    color: ${props => props.color};
    @media (max-width: 767px) {
      padding: 0 10%;
      font-size: 1.3rem;
    }
  }
  .content strong, 
  .content b {
    display: block;
  } 
  .content > span {
    line-height: normal;
    display:inline-block;
    vertical-align: middle;
  }
`

export default Circle
